/*
  单个机构的数据内容
*/
import Vue from 'vue'
import { Wechat } from '@/api'

export default {
  state: {
    id: null,
    name: undefined,
    desc: undefined,
    avatar: undefined,
    creditAwards: {},
    star: null,
    shopOpened: false,
    mobile: undefined,
    moduleOnlineLearn: {},
    moduleMall: {},
    moduleTools: {},
    moduleMine: {},
    moduleHome: {},
    moduleNews: {},
    moduleCourses: {},
    moduleFonts: {},
    payType: null,
    contactPerson: {},
    showServicePopup: false
  },
  mutations: {
    UPDATE_ORGANIZATION (state, organization) {
      [
        'id', 'name', 'desc', 'avatar', 'creditAwards', 'star', 'shopOpened', 'mobile', 'appId',
        'moduleOnlineLearn', 'moduleMall', 'moduleTools', 'moduleMine',
        'moduleHome', 'moduleNews', 'moduleCourses', 'moduleFonts',
        'payType', 'contactPerson'
      ].forEach(key => {
        state[key] = organization[key]
      })
      Vue.ls.set('org', organization)
    },
    SET_SERVICE_SHOW (state, bool) {
      state.showServicePopup = bool
    }
  },
  actions: {
    updateOrganization ({ commit }, organization) {
      const organizationId = organization.id
      return new Promise((resolve, reject) => {
        Wechat.setting({ organizationId }).then(({ appid }) => {
          organization.appId = appid
          console.log('获取appid', { appid })
          commit('UPDATE_ORGANIZATION', organization)
          resolve(appid)
        })
      })
    },
    setServiceShow ({ commit }, bool) {
      commit('SET_SERVICE_SHOW', bool)
    }
  }
}
